<template>
  <div>
    <el-table
      :data="dataList"
      :loading="loading"
      style="width: 100%; height: calc(100vh - 357px);"
    >
      <el-table-column prop="zhtmc" label="主合同名称" align="center"></el-table-column>
      <el-table-column prop="bchtmc" label="补充合同名称" align="center"></el-table-column>
      <el-table-column prop="bchtbh" label="补充合同编号" align="center"></el-table-column>
      <el-table-column prop="bchtjezj" label="补充合同金额" align="center"></el-table-column>
      <el-table-column prop="bchtkssj" label="补充合同开始时间" align="center"></el-table-column>
      <el-table-column prop="bchtjssj" label="补充合同结束时间" align="center"></el-table-column>
      <el-table-column prop="bchtlc" label="补充合同流程" align="center"></el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNumber"
        :page-sizes="[5, 10, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CrmButton from "~component/base/crmButton";
import { mapActions } from 'vuex';

export default {
  components: {
    CrmButton,
  },
  filters: {},
  props: {
    id: String,
  },
  data() {
    return {
      dataList: [],
      loading: false,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions({
      getInsideSupplementList: 'compactInside/getInsideSupplementList',
    }),
    // 点击tab发送请求
    queryList() {
      const param = {
        contractId: this.id,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      }
      this.getInsideSupplementList(param).then(res => {
        this.dataList = res.results
        this.totalCount = res.totalCount
        this.pageNumber = res.pageNumber
        this.pageSize = res.pageSize
      }).catch(e => {
        console.log(e)
      })
    },
    handleSizeChange(value) {
      this.pageSize = value
      this.queryList()
    },
    handleCurrentChange(value) {
      this.pageNumber = value
      this.queryList()
    },
  },
}
</script>
